import { createFileRoute } from '@tanstack/react-router';
import { HeroBanner } from '@/components/HeroBanner';
import { FeaturedProducts } from '@/components/FeaturedProducts';
import { CategoryShowcase } from '@/components/CategoryShowcase';
import { ArtistStory } from '@/components/ArtistStory';
import { Newsletter } from '@/components/Newsletter';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <main>
      <HeroBanner />
      <FeaturedProducts />
      <CategoryShowcase />
      <ArtistStory />
      <Newsletter />
    </main>
  );
}
